module.exports = __webpack_public_path__ + "static/media/IPublico.dfe49cf9.svg";